import React, { useState } from 'react';
import { flex, refetchingStyle as pageGuardBackgroundStyle } from '@fabric-ui/theme';
import { noop } from '@fabric-ui/utils';
import { Box, Button } from '@mui/material';
import { useRouter } from '@tanstack/react-router';
import { AvDialog } from '../AvDialog';

export const AvPageGuard = ({
  children,
  title = 'Navigation Confirmation',
  messageElement = <DefaultMessageElement />,
  onProceed = noop,
  onCancel = noop,
}) => {
  const [showGuard, setShowGuard] = useState(true);
  const router = useRouter();
  return showGuard ? (
    <>
      <AvDialog
        noPadding
        titleVariant="warning"
        title={title}
        open={showGuard}
        onClose={() => {
          router.history.back();
        }}
        footer={
          <Box sx={{ ...flex.justifyEndCenter, gap: 2 }}>
            <Button
              onClick={() => {
                onCancel();
                router.history.back();
              }}>
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                onProceed();
                setShowGuard(false);
              }}>
              Proceed
            </Button>
          </Box>
        }>
        <Box sx={{ px: 3 }}>{messageElement}</Box>
      </AvDialog>
      <Box sx={showGuard ? { ...pageGuardBackgroundStyle } : {}}>{children}</Box>
    </>
  ) : (
    children
  );
};

const DefaultMessageElement = () => (
  <Box sx={{ ...flex.colItemsStart, gap: 2 }}>
    <div>Are you sure you want to proceed?</div>
  </Box>
);
